module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAICAYAAAAm06XyAAAAAXNSR0IArs4c6QAAAN1JREFUKFNjZMABklwNpRjY2BYy/PoVP2/3+WfYlDFiE4xzNhNm5WA4yMDIqM3w///V3z8Y7BftPfUWXS2G5iQ/dV6Gf/x7GRkYTWGK/zP8P83A9NF53qabn5ENQNGc4KDAwcQtto2RkdER3Zb////v//f1ldeCAw9+wOTgmh0cHFiUeb6tY2Bg9MUVDgwM/zff/cIVdODAgT8gNTDNTMk+ZosZGBijcGuEe2LZ3C2nYhkYGP6BNSd5mU1nZGLMIKwRouL/v/8z5m07lcmY5GPezsjAUEGsRkQgMnQAAIrCQ3X19L8xAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bookIcons/smallup.png
// module id = e4Xg
// module chunks = 1